(function () {
	const CM_TO_IN = 0.393701;

	class SizeGuide extends HTMLElement {
		connectedCallback() {
			this.drawer = this.querySelector("modal-drawer");
			this.root = this.querySelector(".size-guide");
			this.toggleInput = this.querySelector(".size-guide__toggle .toggle__input");
			this.unitLabel = this.querySelector("[data-size-guide-unit-label]");
			this.cells = Array.from(
				this.querySelectorAll("[data-size-guide-measure]")
			);

			// Capture each cell's authored centimetre value (its initial text) so
			// switching back to CM restores the exact source formatting (e.g. 41.0).
			this.cells.forEach((cell) => {
				cell.dataset.cm = cell.textContent.trim();
			});

			// Open: internal trigger button(s) + external `size-guide:open` event
			// (dispatched by the pdp-details / variant-picker "size guide" link).
			this.querySelectorAll("[data-size-guide-open]").forEach((btn) =>
				btn.addEventListener("click", () => this.openDrawer(btn))
			);
			this._onOpen = (event) =>
				this.openDrawer(event.detail && event.detail.trigger);
			document.addEventListener("size-guide:open", this._onOpen);

			// Publish `size-guide:close` when the shell dismisses the drawer.
			const closeButton = this.querySelector(".drawer__close");
			const overlay = this.querySelector(".drawer__overlay");
			if (closeButton)
				closeButton.addEventListener("click", () => this.publishClose());
			if (overlay) overlay.addEventListener("click", () => this.publishClose());

			// CM/IN unit switch.
			if (this.toggleInput) {
				this.toggleInput.addEventListener("change", () => this.applyUnit());
				this.applyUnit();
			}
		}

		disconnectedCallback() {
			document.removeEventListener("size-guide:open", this._onOpen);
		}

		openDrawer(trigger) {
			if (this.drawer && typeof this.drawer.open === "function") {
				this.drawer.open(trigger);
			}
		}

		publishClose() {
			document.dispatchEvent(new CustomEvent("size-guide:close"));
		}

		applyUnit() {
			const metric = this.toggleInput.checked; // checked = CM (default)
			const unit = metric ? "cm" : "in";

			if (this.root) this.root.setAttribute("data-unit", unit);

			if (this.unitLabel) {
				const attr = metric ? "data-label-cm" : "data-label-in";
				this.unitLabel.textContent =
					this.unitLabel.getAttribute(attr) || (metric ? "CM" : "IN");
			}

			this.cells.forEach((cell) => {
				const cm = parseFloat(cell.dataset.cm);
				if (Number.isNaN(cm)) return;
				cell.textContent = metric
					? cell.dataset.cm
					: (cm * CM_TO_IN).toFixed(1);
			});
		}
	}

	if (!customElements.get("size-guide")) {
		customElements.define("size-guide", SizeGuide);
	}

	// Delegated opener for external triggers (the PDP variant-picker "Size guide"
	// buttons, incl. the cloned sticky picker). A dedicated selector keeps this
	// separate from the drawer's own internal `[data-size-guide-open]` trigger so
	// the DS-preview path is never double-bound. Guarded so re-injecting this
	// script (floated-form) can't register the listener twice.
	if (!window.__sizeGuideTriggerBound) {
		window.__sizeGuideTriggerBound = true;
		document.addEventListener("click", (event) => {
			const trigger = event.target.closest("[data-size-guide-trigger]");
			if (!trigger) return;
			event.preventDefault();
			document.dispatchEvent(
				new CustomEvent("size-guide:open", { detail: { trigger } })
			);
		});
	}
})();
